/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProjectRequest
 */
export interface CreateProjectRequest {
    /**
     * The display name of your application, shown to end users during the connection flow.
     * @type {string}
     * @memberof CreateProjectRequest
     */
    appName: string;
    /**
     * The unique name for the project. Must contain only letters, numbers, and hyphens. Values are normalized to lowercase on save.
     * @type {string}
     * @memberof CreateProjectRequest
     */
    name: string;
    /**
     * The ID of the organization this project belongs to. Obtain this from the Ampersand Dashboard or by calling `GET /orgs`.
     * @type {string}
     * @memberof CreateProjectRequest
     */
    orgId: string;
}

/**
 * Check if a given object implements the CreateProjectRequest interface.
 */
export function instanceOfCreateProjectRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "appName" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "orgId" in value;

    return isInstance;
}

export function CreateProjectRequestFromJSON(json: any): CreateProjectRequest {
    return CreateProjectRequestFromJSONTyped(json, false);
}

export function CreateProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProjectRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appName': json['appName'],
        'name': json['name'],
        'orgId': json['orgId'],
    };
}

export function CreateProjectRequestToJSON(value?: CreateProjectRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appName': value.appName,
        'name': value.name,
        'orgId': value.orgId,
    };
}

